import React from 'react';
import {paths} from '../common/dictionaries/urls';
import CampaignList from './components/list/index';
import EditCampaign from './components/edit/index';
import CampaignAndChassisQuery from './components/query/index';
import WarrantyCampaignsReport from './components/report/index';
import CampaignPartsOrders from './components/partsOrders/index';

export const campaignRoutes = [
  {'component': <CampaignList />, 'path': paths.CampaignList},
  {'component': <EditCampaign />, 'path': paths.EditCampaign},
  {'component': <EditCampaign />, 'path': paths.CreateCampaign},
  {'component': <EditCampaign />, 'path': paths.ViewCampaign},
  {'component': <CampaignPartsOrders />, 'path': paths.CampaignPartsOrders},
  {'component': <CampaignPartsOrders />, 'path': paths.CampaignPartOrder},
  {
    'component': <CampaignAndChassisQuery />,
    'path': paths.CampaignAndChassisQuery,
  },
  {
    'component': <WarrantyCampaignsReport />,
    'path': paths.WarrantyCampaignsReport,
  },
];
